import { useMutation, useQuery } from "@tanstack/react-query";
export const createQAQueries = (requests) => ({
    useGetActions: (options) => {
        return useQuery({
            queryKey: ["qa", "actions"],
            queryFn: () => requests.getActions(),
            ...options,
        });
    },
    useGenerateMissingScoresheetsForFlight: (options) => {
        return useMutation({
            mutationFn: (payload) => requests.generateMissingScoresheetsForFlight(payload),
            ...options,
        });
    },
    useGenerateMissingScoresheetsForTable: (options) => {
        return useMutation({
            mutationFn: (payload) => requests.generateMissingScoresheetsForTable(payload),
            ...options,
        });
    },
    useGenerateEntries: (options) => {
        return useMutation({
            mutationFn: (payload) => requests.generateEntries(payload),
            ...options,
        });
    },
    usePayEntries: (options) => {
        return useMutation({
            mutationFn: (payload) => requests.payEntries(payload),
            ...options,
        });
    },
    useCheckInEntries: (options) => {
        return useMutation({
            mutationFn: (payload) => requests.checkInEntries(payload),
            ...options,
        });
    },
    useRecodeEntries: (options) => {
        return useMutation({
            mutationFn: (payload) => requests.recodeEntries(payload),
            ...options,
        });
    },
    useCreateFlights: (options) => {
        return useMutation({
            mutationFn: (payload) => requests.createFlights(payload),
            ...options,
        });
    },
    useAssignTables: (options) => {
        return useMutation({
            mutationFn: (payload) => requests.assignTables(payload),
            ...options,
        });
    },
});
//# sourceMappingURL=index.js.map